<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">
            <span i18n>Order line sourcing:</span>
            <span> {{orderLine.product.name}}</span>
        </h5>
        <button (click)="close()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p *ngIf="orderLine.source_order_line">
            This order line is sourced from order:
            <a routerLink="/orders/{{ orderLine.source_order_line.order_id }}">{{ orderLine.source_order_line.order_id }}</a>.
        </p>

        <ng-container *ngIf="orderLine.sourced_order_lines && orderLine.sourced_order_lines.length > 0">
            <table class="table  table-sm  table-striped">
                <thead>
                    <tr>
                        <th i18n>Order</th>
                        <th i18n>Quantity</th>
                        <th class="text-right" i18n>Price</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let sourcedOrderLine of orderLine.sourced_order_lines">
                        <td>
                            <a routerLink="/orders/{{sourcedOrderLine.order.id}}">{{sourcedOrderLine.order.getIdentificationReference()}}</a>
                        </td>
                        <td>{{sourcedOrderLine.quantity}}</td>
                        <td class="text-right">{{sourcedOrderLine.price_final}}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()" i18n>Close</button>
    </div>
</div>
